import React from 'react';
import { BookOverflowWithPatient } from './BookOverflowWithPatient';
import { BookOverflowNoPatient } from './BookOverflowNoPatient';
import { UserData } from '../../../../types/users';

interface IAppointmentSlotCardProps {
  closeForm: () => void;
  selectedPatient?: UserData;
}

export const BookOverflow: React.FunctionComponent<
  IAppointmentSlotCardProps
> = ({ closeForm, selectedPatient }) => {
  return (
    <>
      {selectedPatient ? (
        <BookOverflowWithPatient
          closeForm={closeForm}
          selectedUser={selectedPatient}
        />
      ) : (
        <BookOverflowNoPatient closeForm={() => closeForm()} />
      )}
    </>
  );
};
